import React, { Component } from 'react';

// import logo1 from 'assets/images/logo/switzerland.png';
// import logo2 from 'assets/images/logo/eurail.png';

import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const onLoad = () => {
  document.body.classList.add('no-scroll');
};

export default class RewardsView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
    };
  }

  componentWillMount() {
    document.body.classList.remove('no-scroll');
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        this.setState({
          email: res.response.email,
        });
      }
    });
  }

  render() {
    const {
      email,
    } = this.state;

    return (
      <div>
        <div className="rewards__view">
          <h3>Rewards</h3>
          <h4>Select an option below:</h4>
          <a
            data-fancybox="rewards"
            data-type="iframe"
            data-src={`https://stack.travpromobile.com/form.php?email=${email}`}
            href={`https://stack.travpromobile.com/form.php?email=${email}`}
            key="rewards"
            className="logo"
          >
            {/* <img src={`/${logo1}`} alt="logo" /> */}
            <span>Switzerland</span>
          </a>
          {/* <a className="logo">
            <img src={`/${logo2}`} alt="logo" className="disabled" />
            <span>Coming May, 2020!</span>
          </a> */}
        </div>
      </div>
    );
  }
}
